export const getProfileGreeting = (name?: string | null) => {
    const firstName = name?.trim().split(/\s+/).filter(Boolean)[0];

    return firstName ? `Cześć, ${firstName}` : "Cześć";
};
export const getProfileGreeting = (name?: string | null) => {
    const firstName = name?.trim().split(/\s+/).filter(Boolean)[0];

    return firstName ? `Cześć, ${firstName}` : "Cześć";
};
